// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { ClientProfileMinimalGrantorRelationshipFragment } from '../../clientProfiles/graphql/ClientProfile.generated';
import { GraphViz_ViewFragment, GraphViz_MinimalViewFragment } from '../../graphViz/graphql/GraphVizView.generated';
import { gql } from '@apollo/client';
import { ClientProfileMinimalGrantorRelationshipFragmentDoc } from '../../clientProfiles/graphql/ClientProfile.generated';
import { GraphViz_ViewFragmentDoc, GraphViz_MinimalViewFragmentDoc } from '../../graphViz/graphql/GraphVizView.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityMap_OwnedOwnershipStakeFragment = { __typename?: 'OwnershipStake', id: string, ownedValue: CurrencyUSD, ownershipPercentage?: Percent | null, owningEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, ownedEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, owningIndividual?: { __typename?: 'ClientProfile', id: string, displayName: string, firstName: string, lastName: string, isPrimary: boolean } | null };

export type EntityMap_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, firstName: string, lastName: string, isPrimary: boolean, relationships?: Array<(
    { __typename?: 'ClientProfileRelationship' }
    & ClientProfileMinimalGrantorRelationshipFragment
  )> | null };

export type EntityMap_GrantorClientProfileFragment = (
  { __typename?: 'ClientProfile', ownedOwnershipStakes?: Array<(
    { __typename?: 'OwnershipStake' }
    & EntityMap_OwnedOwnershipStakeFragment
  )> | null }
  & EntityMap_ClientProfileFragment
);

export type EntityMap_OrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null };

export type EntityMap_BeneficiaryConnectionFragment = { __typename?: 'Beneficiary', id: string, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: { __typename?: 'AccessParameter', id: string, kind: Types.AccessParameterKind, amount?: CurrencyUSD | null, percentage?: Percent | null } | null } | null> | null }, individual?: { __typename?: 'ClientProfile', id: string } | null, organization?: { __typename?: 'ClientOrganization', id: string } | null, entity?: { __typename?: 'Entity', id: string } | null };

export type EntityMap_PrincipalConnectionFragment = { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null };

export type EntityMap_GratTrustFragment = { __typename?: 'GRATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, annuities?: Array<{ __typename?: 'GRATAnnuityV2', id: string, paidOn?: Time | null, computedPaymentAmount: CurrencyUSD, actualPaymentAmount: CurrencyUSD, paymentWindowStartDate: Time }> | null, grantor?: (
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_SlatTrustFragment = { __typename?: 'SLATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantor?: (
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  ) | null, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_RevocableTrustFragment = { __typename?: 'RevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_IrrevocableTrustFragment = { __typename?: 'IrrevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_IlitTrustFragment = { __typename?: 'ILITTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null, policies?: Array<{ __typename?: 'InsurancePolicy', id: string, deathBenefitAmount: CurrencyUSD }> | null };

export type EntityMap_QprtTrustFragment = { __typename?: 'QPRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_IndividualPersonalAccountFragment = { __typename?: 'IndividualPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, owner?: (
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_JointPersonalAccountFragment = { __typename?: 'JointPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, owners?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_CustodialPersonalAccountFragment = { __typename?: 'CustodialPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, owner?: (
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_QualifiedTuitionPersonalAccountFragment = { __typename?: 'QualifiedTuitionPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, owner?: (
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_RetirementPersonalAccountFragment = { __typename?: 'RetirementPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, owner?: (
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  ) | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_CltTrustFragment = { __typename?: 'CLTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_CrtTrustFragment = { __typename?: 'CRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, grantors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, lifetimeBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null, remainderBeneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_DonorAdvisedFundFragment = { __typename?: 'DonorAdvisedFund', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, donors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_PrivateFoundationFragment = { __typename?: 'PrivateFoundation', id: string, inEstateStatus: Types.EntityInEstateStatus, currentValue: CurrencyUSD, donors?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, beneficiaries?: Array<(
    { __typename?: 'Beneficiary' }
    & EntityMap_BeneficiaryConnectionFragment
  )> | null };

export type EntityMap_BusinessEntity_CCorpBusinessEntity_Fragment = { __typename?: 'CCorpBusinessEntity', id: string, currentValue: CurrencyUSD };

export type EntityMap_BusinessEntity_GpBusinessEntity_Fragment = { __typename?: 'GPBusinessEntity', id: string, currentValue: CurrencyUSD };

export type EntityMap_BusinessEntity_LlcBusinessEntity_Fragment = { __typename?: 'LLCBusinessEntity', id: string, currentValue: CurrencyUSD };

export type EntityMap_BusinessEntity_LpBusinessEntity_Fragment = { __typename?: 'LPBusinessEntity', id: string, currentValue: CurrencyUSD };

export type EntityMap_BusinessEntity_SCorpBusinessEntity_Fragment = { __typename?: 'SCorpBusinessEntity', id: string, currentValue: CurrencyUSD };

export type EntityMap_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment = { __typename?: 'SoleProprietorshipBusinessEntity', id: string, currentValue: CurrencyUSD };

export type EntityMap_BusinessEntityFragment = EntityMap_BusinessEntity_CCorpBusinessEntity_Fragment | EntityMap_BusinessEntity_GpBusinessEntity_Fragment | EntityMap_BusinessEntity_LlcBusinessEntity_Fragment | EntityMap_BusinessEntity_LpBusinessEntity_Fragment | EntityMap_BusinessEntity_SCorpBusinessEntity_Fragment | EntityMap_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment;

export type EntityMap_InsurancePersonalAccountFragment = { __typename?: 'InsurancePersonalAccount', id: string, currentValue: CurrencyUSD, owners?: Array<(
    { __typename?: 'Principal' }
    & EntityMap_PrincipalConnectionFragment
  )> | null, policies?: Array<{ __typename?: 'InsurancePolicy', id: string, deathBenefitAmount: CurrencyUSD }> | null };

export type EntityMap_NodeFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: (
    { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, legalName?: string | null }
    & EntityMap_BusinessEntity_CCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'CLTTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_CltTrustFragment
  ) | (
    { __typename?: 'CRTTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_CrtTrustFragment
  ) | (
    { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, legalName?: string | null }
    & EntityMap_CustodialPersonalAccountFragment
  ) | (
    { __typename?: 'DonorAdvisedFund', id: string, displayName: string, legalName?: string | null }
    & EntityMap_DonorAdvisedFundFragment
  ) | (
    { __typename?: 'GPBusinessEntity', id: string, displayName: string, legalName?: string | null }
    & EntityMap_BusinessEntity_GpBusinessEntity_Fragment
  ) | (
    { __typename?: 'GRATTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_GratTrustFragment
  ) | (
    { __typename?: 'ILITTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_IlitTrustFragment
  ) | (
    { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, legalName?: string | null }
    & EntityMap_IndividualPersonalAccountFragment
  ) | (
    { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, legalName?: string | null }
    & EntityMap_InsurancePersonalAccountFragment
  ) | (
    { __typename?: 'IrrevocableTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_IrrevocableTrustFragment
  ) | (
    { __typename?: 'JointPersonalAccount', id: string, displayName: string, legalName?: string | null }
    & EntityMap_JointPersonalAccountFragment
  ) | (
    { __typename?: 'LLCBusinessEntity', id: string, displayName: string, legalName?: string | null }
    & EntityMap_BusinessEntity_LlcBusinessEntity_Fragment
  ) | (
    { __typename?: 'LPBusinessEntity', id: string, displayName: string, legalName?: string | null }
    & EntityMap_BusinessEntity_LpBusinessEntity_Fragment
  ) | (
    { __typename?: 'PrivateFoundation', id: string, displayName: string, legalName?: string | null }
    & EntityMap_PrivateFoundationFragment
  ) | (
    { __typename?: 'QPRTTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_QprtTrustFragment
  ) | (
    { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, legalName?: string | null }
    & EntityMap_QualifiedTuitionPersonalAccountFragment
  ) | (
    { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, legalName?: string | null }
    & EntityMap_RetirementPersonalAccountFragment
  ) | (
    { __typename?: 'RevocableTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_RevocableTrustFragment
  ) | (
    { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, legalName?: string | null }
    & EntityMap_BusinessEntity_SCorpBusinessEntity_Fragment
  ) | (
    { __typename?: 'SLATTrust', id: string, displayName: string, legalName?: string | null }
    & EntityMap_SlatTrustFragment
  ) | (
    { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, legalName?: string | null }
    & EntityMap_BusinessEntity_SoleProprietorshipBusinessEntity_Fragment
  ), ownedByStakes?: Array<(
    { __typename?: 'OwnershipStake' }
    & EntityMap_OwnedOwnershipStakeFragment
  )> | null };

export type EntityMap_HouseholdFragment = { __typename?: 'Household', id: string, possibleGrantors: Array<(
    { __typename?: 'ClientProfile' }
    & EntityMap_GrantorClientProfileFragment
  )>, clientProfiles?: Array<(
    { __typename?: 'ClientProfile' }
    & EntityMap_GrantorClientProfileFragment
  )> | null, clientOrganizations?: Array<(
    { __typename?: 'ClientOrganization' }
    & EntityMap_OrganizationFragment
  )> | null, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & EntityMap_NodeFragment
      ) | null } | null> | null } };

export type EntityMapQueryVariables = Types.Exact<{
  householdWhere: Types.HouseholdWhereInput;
  entitiesWhere: Types.EntityWhereInput;
  entityGraphViewWhere: Types.EntityGraphViewWhereInput;
  allEntityGraphViewsWhere: Types.EntityGraphViewWhereInput;
}>;


export type EntityMapQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & EntityMap_HouseholdFragment
      ) | null } | null> | null }, entityGraphViews: { __typename?: 'EntityGraphViewConnection', edges?: Array<{ __typename?: 'EntityGraphViewEdge', node?: (
        { __typename?: 'EntityGraphView' }
        & GraphViz_ViewFragment
      ) | null } | null> | null }, allEntityGraphViews: { __typename?: 'EntityGraphViewConnection', edges?: Array<{ __typename?: 'EntityGraphViewEdge', node?: (
        { __typename?: 'EntityGraphView' }
        & GraphViz_MinimalViewFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    EntityMap: 'EntityMap' as const
  },
  Fragment: {
    EntityMap_OwnedOwnershipStake: 'EntityMap_OwnedOwnershipStake' as const,
    EntityMap_ClientProfile: 'EntityMap_ClientProfile' as const,
    EntityMap_GrantorClientProfile: 'EntityMap_GrantorClientProfile' as const,
    EntityMap_Organization: 'EntityMap_Organization' as const,
    EntityMap_BeneficiaryConnection: 'EntityMap_BeneficiaryConnection' as const,
    EntityMap_PrincipalConnection: 'EntityMap_PrincipalConnection' as const,
    EntityMap_GratTrust: 'EntityMap_GratTrust' as const,
    EntityMap_SlatTrust: 'EntityMap_SlatTrust' as const,
    EntityMap_RevocableTrust: 'EntityMap_RevocableTrust' as const,
    EntityMap_IrrevocableTrust: 'EntityMap_IrrevocableTrust' as const,
    EntityMap_ILITTrust: 'EntityMap_ILITTrust' as const,
    EntityMap_QPRTTrust: 'EntityMap_QPRTTrust' as const,
    EntityMap_IndividualPersonalAccount: 'EntityMap_IndividualPersonalAccount' as const,
    EntityMap_JointPersonalAccount: 'EntityMap_JointPersonalAccount' as const,
    EntityMap_CustodialPersonalAccount: 'EntityMap_CustodialPersonalAccount' as const,
    EntityMap_QualifiedTuitionPersonalAccount: 'EntityMap_QualifiedTuitionPersonalAccount' as const,
    EntityMap_RetirementPersonalAccount: 'EntityMap_RetirementPersonalAccount' as const,
    EntityMap_CLTTrust: 'EntityMap_CLTTrust' as const,
    EntityMap_CRTTrust: 'EntityMap_CRTTrust' as const,
    EntityMap_DonorAdvisedFund: 'EntityMap_DonorAdvisedFund' as const,
    EntityMap_PrivateFoundation: 'EntityMap_PrivateFoundation' as const,
    EntityMap_BusinessEntity: 'EntityMap_BusinessEntity' as const,
    EntityMap_InsurancePersonalAccount: 'EntityMap_InsurancePersonalAccount' as const,
    EntityMap_Node: 'EntityMap_Node' as const,
    EntityMap_Household: 'EntityMap_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityMap_ClientProfileFragmentDoc = gql`
    fragment EntityMap_ClientProfile on ClientProfile {
  id
  displayName
  firstName
  lastName
  isPrimary
  relationships {
    ...ClientProfileMinimalGrantorRelationship
  }
}
    ${ClientProfileMinimalGrantorRelationshipFragmentDoc}`;
export const EntityMap_OwnedOwnershipStakeFragmentDoc = gql`
    fragment EntityMap_OwnedOwnershipStake on OwnershipStake {
  id
  ownedValue
  ownershipPercentage
  owningEntity {
    id
    subtype {
      id
      displayName
    }
  }
  ownedEntity {
    id
    subtype {
      id
      displayName
    }
  }
  owningIndividual {
    id
    displayName
    firstName
    lastName
    isPrimary
  }
}
    `;
export const EntityMap_GrantorClientProfileFragmentDoc = gql`
    fragment EntityMap_GrantorClientProfile on ClientProfile {
  ...EntityMap_ClientProfile
  ownedOwnershipStakes {
    ...EntityMap_OwnedOwnershipStake
  }
}
    ${EntityMap_ClientProfileFragmentDoc}
${EntityMap_OwnedOwnershipStakeFragmentDoc}`;
export const EntityMap_OrganizationFragmentDoc = gql`
    fragment EntityMap_Organization on ClientOrganization {
  id
  name
  kind
}
    `;
export const EntityMap_PrincipalConnectionFragmentDoc = gql`
    fragment EntityMap_PrincipalConnection on Principal {
  id
  individual {
    id
  }
}
    `;
export const EntityMap_BeneficiaryConnectionFragmentDoc = gql`
    fragment EntityMap_BeneficiaryConnection on Beneficiary {
  id
  accessParameters {
    edges {
      node {
        id
        kind
        amount
        percentage
      }
    }
  }
  individual {
    id
  }
  organization {
    id
  }
  entity {
    id
  }
}
    `;
export const EntityMap_GratTrustFragmentDoc = gql`
    fragment EntityMap_GratTrust on GRATTrust {
  id
  inEstateStatus
  currentValue
  annuities {
    id
    paidOn
    computedPaymentAmount
    actualPaymentAmount
    paymentWindowStartDate
  }
  grantor {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_SlatTrustFragmentDoc = gql`
    fragment EntityMap_SlatTrust on SLATTrust {
  id
  inEstateStatus
  currentValue
  grantor {
    ...EntityMap_PrincipalConnection
  }
  lifetimeBeneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
  remainderBeneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_RevocableTrustFragmentDoc = gql`
    fragment EntityMap_RevocableTrust on RevocableTrust {
  id
  inEstateStatus
  currentValue
  grantors {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_IrrevocableTrustFragmentDoc = gql`
    fragment EntityMap_IrrevocableTrust on IrrevocableTrust {
  id
  inEstateStatus
  currentValue
  grantors {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_IlitTrustFragmentDoc = gql`
    fragment EntityMap_ILITTrust on ILITTrust {
  id
  inEstateStatus
  currentValue
  grantors {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
  policies {
    id
    deathBenefitAmount
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_QprtTrustFragmentDoc = gql`
    fragment EntityMap_QPRTTrust on QPRTTrust {
  id
  inEstateStatus
  currentValue
  grantors {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_IndividualPersonalAccountFragmentDoc = gql`
    fragment EntityMap_IndividualPersonalAccount on IndividualPersonalAccount {
  id
  inEstateStatus
  currentValue
  owner {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_JointPersonalAccountFragmentDoc = gql`
    fragment EntityMap_JointPersonalAccount on JointPersonalAccount {
  id
  inEstateStatus
  currentValue
  owners {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_CustodialPersonalAccountFragmentDoc = gql`
    fragment EntityMap_CustodialPersonalAccount on CustodialPersonalAccount {
  id
  inEstateStatus
  currentValue
  owner {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_QualifiedTuitionPersonalAccountFragmentDoc = gql`
    fragment EntityMap_QualifiedTuitionPersonalAccount on QualifiedTuitionPersonalAccount {
  id
  inEstateStatus
  currentValue
  owner {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_RetirementPersonalAccountFragmentDoc = gql`
    fragment EntityMap_RetirementPersonalAccount on RetirementPersonalAccount {
  id
  inEstateStatus
  currentValue
  owner {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_CltTrustFragmentDoc = gql`
    fragment EntityMap_CLTTrust on CLTTrust {
  id
  inEstateStatus
  currentValue
  grantors {
    ...EntityMap_PrincipalConnection
  }
  lifetimeBeneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
  remainderBeneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_CrtTrustFragmentDoc = gql`
    fragment EntityMap_CRTTrust on CRTTrust {
  id
  inEstateStatus
  currentValue
  grantors {
    ...EntityMap_PrincipalConnection
  }
  lifetimeBeneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
  remainderBeneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_DonorAdvisedFundFragmentDoc = gql`
    fragment EntityMap_DonorAdvisedFund on DonorAdvisedFund {
  id
  inEstateStatus
  currentValue
  donors {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_PrivateFoundationFragmentDoc = gql`
    fragment EntityMap_PrivateFoundation on PrivateFoundation {
  id
  inEstateStatus
  currentValue
  donors {
    ...EntityMap_PrincipalConnection
  }
  beneficiaries {
    ...EntityMap_BeneficiaryConnection
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}
${EntityMap_BeneficiaryConnectionFragmentDoc}`;
export const EntityMap_BusinessEntityFragmentDoc = gql`
    fragment EntityMap_BusinessEntity on BusinessEntity {
  id
  currentValue
}
    `;
export const EntityMap_InsurancePersonalAccountFragmentDoc = gql`
    fragment EntityMap_InsurancePersonalAccount on InsurancePersonalAccount {
  id
  currentValue
  owners {
    ...EntityMap_PrincipalConnection
  }
  policies {
    id
    deathBenefitAmount
  }
}
    ${EntityMap_PrincipalConnectionFragmentDoc}`;
export const EntityMap_NodeFragmentDoc = gql`
    fragment EntityMap_Node on Entity {
  id
  kind
  subtype {
    id
    displayName
    legalName
    ...EntityMap_GratTrust
    ...EntityMap_SlatTrust
    ...EntityMap_RevocableTrust
    ...EntityMap_IrrevocableTrust
    ...EntityMap_ILITTrust
    ...EntityMap_QPRTTrust
    ...EntityMap_IndividualPersonalAccount
    ...EntityMap_JointPersonalAccount
    ...EntityMap_CustodialPersonalAccount
    ...EntityMap_QualifiedTuitionPersonalAccount
    ...EntityMap_RetirementPersonalAccount
    ...EntityMap_CLTTrust
    ...EntityMap_CRTTrust
    ...EntityMap_DonorAdvisedFund
    ...EntityMap_PrivateFoundation
    ...EntityMap_BusinessEntity
    ...EntityMap_InsurancePersonalAccount
  }
  ownedByStakes {
    ...EntityMap_OwnedOwnershipStake
  }
}
    ${EntityMap_GratTrustFragmentDoc}
${EntityMap_SlatTrustFragmentDoc}
${EntityMap_RevocableTrustFragmentDoc}
${EntityMap_IrrevocableTrustFragmentDoc}
${EntityMap_IlitTrustFragmentDoc}
${EntityMap_QprtTrustFragmentDoc}
${EntityMap_IndividualPersonalAccountFragmentDoc}
${EntityMap_JointPersonalAccountFragmentDoc}
${EntityMap_CustodialPersonalAccountFragmentDoc}
${EntityMap_QualifiedTuitionPersonalAccountFragmentDoc}
${EntityMap_RetirementPersonalAccountFragmentDoc}
${EntityMap_CltTrustFragmentDoc}
${EntityMap_CrtTrustFragmentDoc}
${EntityMap_DonorAdvisedFundFragmentDoc}
${EntityMap_PrivateFoundationFragmentDoc}
${EntityMap_BusinessEntityFragmentDoc}
${EntityMap_InsurancePersonalAccountFragmentDoc}
${EntityMap_OwnedOwnershipStakeFragmentDoc}`;
export const EntityMap_HouseholdFragmentDoc = gql`
    fragment EntityMap_Household on Household {
  id
  possibleGrantors {
    ...EntityMap_GrantorClientProfile
  }
  clientProfiles {
    ...EntityMap_GrantorClientProfile
  }
  clientOrganizations {
    ...EntityMap_Organization
  }
  entities(where: $entitiesWhere) {
    edges {
      node {
        ...EntityMap_Node
      }
    }
  }
}
    ${EntityMap_GrantorClientProfileFragmentDoc}
${EntityMap_OrganizationFragmentDoc}
${EntityMap_NodeFragmentDoc}`;
export const EntityMapDocument = gql`
    query EntityMap($householdWhere: HouseholdWhereInput!, $entitiesWhere: EntityWhereInput!, $entityGraphViewWhere: EntityGraphViewWhereInput!, $allEntityGraphViewsWhere: EntityGraphViewWhereInput!) {
  households(where: $householdWhere) {
    edges {
      node {
        ...EntityMap_Household
      }
    }
  }
  entityGraphViews(where: $entityGraphViewWhere) {
    edges {
      node {
        ...GraphViz_View
      }
    }
  }
  allEntityGraphViews: entityGraphViews(where: $allEntityGraphViewsWhere) {
    edges {
      node {
        ...GraphViz_MinimalView
      }
    }
  }
}
    ${EntityMap_HouseholdFragmentDoc}
${GraphViz_ViewFragmentDoc}
${GraphViz_MinimalViewFragmentDoc}`;

/**
 * __useEntityMapQuery__
 *
 * To run a query within a React component, call `useEntityMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMapQuery({
 *   variables: {
 *      householdWhere: // value for 'householdWhere'
 *      entitiesWhere: // value for 'entitiesWhere'
 *      entityGraphViewWhere: // value for 'entityGraphViewWhere'
 *      allEntityGraphViewsWhere: // value for 'allEntityGraphViewsWhere'
 *   },
 * });
 */
export function useEntityMapQuery(baseOptions: Apollo.QueryHookOptions<EntityMapQuery, EntityMapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityMapQuery, EntityMapQueryVariables>(EntityMapDocument, withFetchPolicyContext(options));
      }
export function useEntityMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityMapQuery, EntityMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityMapQuery, EntityMapQueryVariables>(EntityMapDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEntityMapSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityMapQuery, EntityMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityMapQuery, EntityMapQueryVariables>(EntityMapDocument, withFetchPolicyContext(options));
        }
export type EntityMapQueryHookResult = ReturnType<typeof useEntityMapQuery>;
export type EntityMapLazyQueryHookResult = ReturnType<typeof useEntityMapLazyQuery>;
export type EntityMapSuspenseQueryHookResult = ReturnType<typeof useEntityMapSuspenseQuery>;
export type EntityMapQueryResult = Apollo.QueryResult<EntityMapQuery, EntityMapQueryVariables>;